import { ADD_USER_PREFERENCE, REMOVE_USER_PREFERENCE, MODIFY_USER_PREFERENCE_SUCCESS, MODIFY_USER_PREFERENCE_FAIL } from '../constants/ActionTypes';

export function addUserPreference(id, values) {
    return {
        type: ADD_USER_PREFERENCE,
        payload: { id, values },
    };
}

export function removeUserPreference(id, values) {
    return {
        type: REMOVE_USER_PREFERENCE,
        payload: { id, values },
    };
}

export function modifyUserPreferenceSuccess() {
    return {
        type: MODIFY_USER_PREFERENCE_SUCCESS,
    };
}

export function modifyUserPreferenceFail() {
    return {
        type: MODIFY_USER_PREFERENCE_FAIL,
    };
}
